<!-- <div class="card">

    <div class="card-header   d-flex  align-items-center">
        <mat-icon>local_bar</mat-icon>
        <h4 style="margin-bottom: 0px;" class="text-truncate"> &nbsp; &nbsp; {{product.name}}</h4>
        <span class="spacer"></span>
        <div *ngIf="productShopping ">
            <b class="float-end"> Cantidad : {{productShopping.quantity}}</b>
        </div>
    </div>
    <div class="card-body">
        <div class="row d-flex  align-items-center ">
            <div class="col-3">
                <img class="card-img-top" [src]="product.image">

            </div>
            <div class="col-4">
                <div class="col-12   d-flex  align-items-center row m-0 p-0">

                    <p class="card-text ">$ {{product.price }}</p>
                    <p class="card-text text-truncate-2-line">{{product.description}}</p>
                </div>
            </div>

            <div class="col-5 row" style="margin-left: 0px;margin-right: 0px; ">
                <div style=" touch-action: manipulation;" *ngIf="productShopping && productShopping.quantity >1"
                    class="col-6  d-flex justify-content-center">
                    <button (click)="reduceProduct(product)" mat-mini-fab color="warn">
                        <mat-icon>remove</mat-icon>
                    </button>
                </div>
                <div style=" touch-action: manipulation;" *ngIf="productShopping && productShopping.quantity ===1"
                    class="col-6  d-flex justify-content-center">
                    <button (click)="removeProduct(product)" mat-mini-fab color="warn">
                        <mat-icon>delete</mat-icon>
                    </button>
                </div>
                <div class="col-6  d-flex justify-content-center" *ngIf="!productShopping"></div>
                <div style=" touch-action: manipulation;" class="col-6 d-flex justify-content-center">
                    <button (click)=" addProduct(product)" mat-mini-fab color="warn">
                        <mat-icon>add</mat-icon>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div> -->


<!-- <div class="card">
  <div class=" col-12 ">
    <mat-icon style="font-size: 50px; color: black;height: 100%;
    width: 100%;" matSuffix>local_activity</mat-icon>
  </div>

  <div class="card-footer text-muted text-center">
    <div class="d-flex justify-content-center  align-items-center">
      <mat-icon>location_on</mat-icon>
      <a style="text-decoration: none;color:unset" target="_blank">
        <h5 style="margin-bottom: 0px;" class="text-truncate-2-line">asda</h5>

      </a>
    </div>
  </div>
</div> -->


<div class="card col-12 col-md-8 col-lg-6 col-xl-6 ">
    <div class="card-header   d-flex  align-items-center">
        <mat-icon style="color: #5271ff">local_bar</mat-icon>
        <h4 style="margin-bottom: 0px;" class="text-truncate text-uppercase">

            <!-- <font style="color: #5271ff">⦿ </font> -->
            &nbsp; &nbsp; {{ product.name}}
        </h4>
        <span class="spacer"></span>

        <div *ngIf="productShopping ">
            <b class="float-end"> Cantidad : {{productShopping.quantity}}</b>
        </div>
    </div>
    <div class="card-body">
        <div class="row d-flex  align-items-center justify-content-center  no-padding no-margin ">
            <div class="col-8 col-md-9 row d-flex  align-items-center no-padding no-margin">


                <div class="col-3    no-padding no-margin ">
                    <!-- <mat-icon style="font-size: 38px;height: 100%;
            width: 100%;" class="col-12" matSuffix>local_bar</mat-icon> -->

                    <img class="card-img-top" [src]="product.image">
                </div>

                <div class="col-9 text-center no-padding no-margin ">
                    <p class="card-text " style="font-size: 20px;">$ {{product.price |number}}
                        <!-- <p class="card-text text-truncate-2-line">{{product.desc}}</p> -->


                </div>





            </div>
            <div *ngIf="!product.exhausted" class="col-4 col-md-3 row no-padding no-margin">
                <div style=" touch-action: manipulation;" *ngIf="productShopping && productShopping.quantity >1"
                    class="col-6  d-flex justify-content-center no-padding no-margin">
                    <button (click)="reduceProduct(product)" mat-mini-fab color="primary">
                        <mat-icon>remove</mat-icon>
                    </button>
                </div>



                <div style=" touch-action: manipulation;" *ngIf="productShopping && productShopping.quantity ===1"
                    class="col-6  d-flex justify-content-center no-padding no-margin">
                    <button (click)="removeProduct(product)" mat-mini-fab color="primary">
                        <mat-icon>delete</mat-icon>
                    </button>
                </div>



                <div *ngIf="!productShopping" style=" touch-action: manipulation;"
                    class="col-6  d-flex justify-content-center no-padding no-margin">
                    <button mat-mini-fab style="  background-color: #a1a1a1;">
                        <mat-icon>remove</mat-icon>
                    </button>
                </div>

                <!-- <div class="col-6  d-flex justify-content-center no-padding no-margin" *ngIf="!productShopping"></div> -->

                <div *ngIf="quantityTicket < quantityAccept" style=" touch-action: manipulation;"
                    class="col-6 d-flex justify-content-center no-padding no-margin">
                    <button (click)=" addProduct(product)" mat-mini-fab color="primary">
                        <mat-icon>add</mat-icon>
                    </button>
                </div>


                <div *ngIf="productShopping && quantityTicket===quantityAccept" style=" touch-action: manipulation;"
                    class="col-6  d-flex justify-content-center no-padding no-margin">
                    <button mat-mini-fab style="  background-color: #a1a1a1;">
                        <mat-icon>add</mat-icon>
                    </button>
                </div>


            </div>



            <div *ngIf="product.exhausted" class="col-4 col-md-3 row no-padding  d-flex justify-content-center"
                style="margin-left: 0px;margin-right: 0px; ">
                <div class="col-12 col-md-10  no-padding">
                    <img src="../../../assets/texts/tickets-exhausted.svg" style="width: 100%" alt="">
                </div>

            </div>


            <!-- <hr class="col-12 mt-3"> -->
            <div class="col-12   d-flex  align-items-center row mt-1">
                <div class="col-12  no-padding no-margin text-center ">
                    <p class="p-font-12 card-text text-truncate-2-line mt-2">
                        {{product.description}}
                    </p>
                </div>

                <!--  <p class="p-font-12 card-text text-truncate"> Cierre Venta {{product.dateSaleClose | date : 'dd/MM/yy, h:mm a' :
            'GMT'}}</p>
          <p class="p-font-12 card-text text-truncate"> Limite de Uso {{product.dateUseClose | date : 'dd/MM/yy, h:mm a' :
            'GMT'}}</p> -->

            </div>
        </div>
    </div>

</div>